<template>
  <div class="homepage-data-panel">
    <div v-if="isConsultTeacher && isQingtingTeacher" class="swiper-view">
      <div v-swiper:mySwiper="swiperOption">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(blocks, index) in swiperBlocks"
            :key="index"
          >
            <ul class="num-block-list">
              <li class="block" v-for="(item, index) in blocks" :key="index">
                <div class="block-top DharmaTypeBebasKai">
                  <p v-html="item.label"></p>
                </div>
                <div class="block-bottom" v-html="item.name"></div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="swiper-pagination data-panel-swiper-pagination"></div>
    </div>
    <ul v-else class="num-block-list">
      <li class="block" v-for="(item, index) in blocks" :key="index">
        <div class="block-top DharmaTypeBebasKai">
          <p v-html="item.label"></p>
        </div>
        <div class="block-bottom" v-html="item.name"></div>
      </li>
    </ul>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { genCustomFonts } from 'utils/homepageUtil.js'

export default {
  computed: {
    ...mapGetters({
      isConsultTeacher: 'homepage/isConsultTeacher',
      isQingtingTeacher: 'homepage/isQingtingTeacher'
    }),
    basicInfo() {
      return this.$store.state.homepage.basicInfo || {}
    },
    showSwiper() {
      return this.isConsultTeacher && this.isQingtingTeacher
    },
    swiperBlocks() {
      return [this.consultBlock, this.qingsuBlock]
    },
    blocks() {
      if (this.isConsultTeacher) {
        return this.consultBlock
      }
      return this.isQingtingTeacher ? this.qingsuBlock : this.normalBlock
    },
    consultBlock() {
      const { achieve_count = {} } = this.basicInfo
      let {
        consult_num,
        service_duration,
        experience_year = {},
        fans_num
      } = achieve_count
      const { year, month } = experience_year

      const list = [
        {
          name: `咨询人数`,
          get label() {
            let str = ''
            if (consult_num.includes('近')) {
              str = '<span class="bb-text">近</span>'
              consult_num = consult_num.slice(1)
            }
            return str + genCustomFonts(consult_num)
          }
        },
        {
          name: `服务时长`,
          get label() {
            let str = ''
            if (service_duration.includes('近')) {
              str = '<span class="bb-text">近</span>'
              service_duration = service_duration.slice(1)
            }
            return str + genCustomFonts(service_duration)
          }
        },
        {
          name: `粉丝数`,
          get label() {
            return genCustomFonts(fans_num)
          },
          hide: +fans_num < 20 || this.mixinShowStudioInfo
        },
        {
          name: `从业年限`,
          get label() {
            const m = genCustomFonts(month)
            const y = genCustomFonts(year)
            const arr = []
            if (+month > 0) {
              arr.push(`${m}<span class="bb-text">月</span>`)
            }
            if (+year > 0) {
              arr.unshift(`${y}<span class="bb-text">年</span>`)
            }
            return arr.join('')
          },
          hide: !year && !month
        }
      ]
      return list.filter(item => !item.hide)
    },
    qingsuBlock() {
      const { qing_info = {} } = this.basicInfo
      let { qingnum, service_duration, goodrate, quick_rate } = qing_info
      return [
        {
          name: `倾诉人数`,
          get label() {
            let str = ''
            if (qingnum.includes('近')) {
              str = '<span class="bb-text">近</span>'
              qingnum = qingnum.slice(1)
            }
            return str + genCustomFonts(qingnum)
          }
        },
        {
          name: `倾诉时长`,
          get label() {
            let str = ''
            if (service_duration.includes('近')) {
              str = '<span class="bb-text">近</span>'
              service_duration = service_duration.slice(1)
            }
            return str + genCustomFonts(service_duration)
          }
        },
        {
          name: `好评率`,
          get label() {
            const rate = Number(goodrate || 0).toFixed(1)
            return genCustomFonts(+rate) + `<span class="bb-text">%</span>`
          }
        },
        {
          name: `快速响应率`,
          get label() {
            return genCustomFonts(quick_rate) + `<span class="bb-text">%</span>`
          }
        }
      ]
    },
    normalBlock() {
      const { achieve_count = {} } = this.basicInfo
      const {
        influence_num = 0,
        praise_num = 0,
        follow_num = 0,
        fans_num = 0
      } = achieve_count
      return [
        {
          name: `浪花值`,
          get label() {
            return genCustomFonts(influence_num)
          }
        },
        {
          name: `获赞数`,
          get label() {
            return genCustomFonts(praise_num)
          }
        },
        {
          name: `关注`,
          get label() {
            return genCustomFonts(follow_num)
          }
        },
        {
          name: `粉丝`,
          get label() {
            return genCustomFonts(fans_num)
          }
        }
      ]
    },
    swiperOption() {
      return {
        loop: false,
        autoplay: false,
        centeredSlides: true,
        observer: true,
        observeParents: true,
        pagination: {
          el: '.data-panel-swiper-pagination'
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.homepage-data-panel {
  width: calc(10rem- 184px);
  .num-block-list {
    display: flex;
    align-items: center;
    &:not(:first-child) {
      margin-top: 40px;
    }
    .block {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      flex: 1;
      position: relative;
      .block-top {
        font-size: 34px;
        font-family: BebasKai;
        color: #21252d;
        margin-bottom: 8px;
        height: 34px;
        p {
          display: flex;
          align-items: baseline;
        }
      }
      .block-bottom {
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #9da3ac;
        line-height: 24px;
      }
      &:not(:last-child)::after {
        content: '';
        width: 1px;
        height: 24px;
        background-color: #eaeaea;
        position: absolute;
        bottom: 0;
        right: 0;
      }
    }
    ::v-deep .bb-num {
      font-size: 34px;
      line-height: 34px;
    }
    ::v-deep .bb-text {
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      line-height: 20px;
      margin: 0 2px;
    }
  }
  .swiper-view {
    position: relative;
    &::before,
    &::after {
      position: absolute;
      content: '';
      width: 10px;
      top: 0;
      bottom: 0;
      pointer-events: none;
      z-index: 1;
    }
    &::before {
      left: 0;
      background: linear-gradient(90deg, #fff, hsla(0, 0%, 100%, 0));
    }
    &::after {
      right: 0;
      background: linear-gradient(90deg, hsla(0, 0%, 100%, 0), #fff);
    }
  }
  .swiper-pagination {
    position: absolute;
    bottom: -34px;
    left: 50%;
    height: 6px;
    transform: translate(-50%);
    display: flex;
    align-items: center;
    /deep/ .swiper-pagination-bullet {
      display: block;
      width: 18px;
      height: 6px;
      border-radius: 4px;
      background: rgba(105, 130, 250, 0.4);
      border-radius: 4px;
      &-active {
        background: #6982fa;
      }
    }
  }
}
</style>
